export default __webpack_public_path__ + "static/media/icon-close.4df22d6b.svg";